import { Construction } from 'lucide-react';
import { useLocation } from 'react-router-dom';

import { navItemFor } from '@/app/navigation';
import { Page, PageHeader, Panel } from '@/components/layout/Page';
import { EmptyState } from '@/components/ui/EmptyState';

/**
 * A screen the navigation reaches but the plan has not built yet.
 *
 * Named for what it is rather than dressed up as something half-working. Each is
 * replaced by its real screen in its own phase.
 */
const PHASE_FOR: Record<string, string> = {};

export function PendingScreen() {
  const location = useLocation();
  const item = navItemFor(location.pathname);
  const phase = PHASE_FOR[location.pathname] ?? 'a later phase';

  return (
    <Page>
      <PageHeader
        title={item?.label ?? 'Not built yet'}
        description="The navigation, permissions and layout are in place. This screen arrives with its own phase."
      />
      <Panel>
        <EmptyState
          icon={<Construction size={21} />}
          title="Not built yet"
          body={`Scheduled for ${phase}.`}
        />
      </Panel>
    </Page>
  );
}
